module.exports = __webpack_public_path__ + "static/media/canCorrect.f3a2df31.png";